import { LakehouseDataSource } from "@/api/temp/UnifiedLakehouseService";

/**
 * Connected datasources for the Unified Lakehouse preview.
 * Keep this list as the single source-of-truth for datasource id/name/type.
 */
export const snowflakeLakehouseDataSource: LakehouseDataSource = {
  id: "8a4882209d962822019d9a67628e0f91",
  name: "ABANK_FINANCE",
  type: "snowflake",
};

export const dremioLakehouseDataSource: LakehouseDataSource = {
  id: "8a4882fb9ed38664019ed3d56ff1066b",
  name: "Dremio Nessie Lakehouse",
  type: "dremio",
};

export const lakehouseDataSources: LakehouseDataSource[] = [
  snowflakeLakehouseDataSource,
  dremioLakehouseDataSource,
];

export const DEMO_DATASOURCE_IDS = {
  snowflake: snowflakeLakehouseDataSource.id,
  dremio: dremioLakehouseDataSource.id,
} as const;

